<template>
  <div class="app-container">
    <div class="wt-form-inputs-container">
      <div class="wt-form-inputs-content">
        <el-form size="small" :inline="true" class="wt-form-inputs">
          <el-form-item label="时间：">
            <el-date-picker v-model="form.dataTimeRange"
              type="datetimerange" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']" :unlink-panels="true">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="区域负责人：">
            <el-select v-model="form.areaManagerId" filterable placeholder="请选择">
                <el-option
                  v-for="item in areaManagerOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
            </el-select>
          </el-form-item>
          <el-button size="small" type="primary" @click="toClickAction('search')">查询</el-button>
          <el-button size="small"  @click="toClickAction('reset')">重置</el-button>
        </el-form>
      </div>
    </div>
    <div class="chart-container">
      <div class="chart-item">
        <div class="chart-item-tit">可回收物投递出库图</div>
        <wt-auth class="search-form-btn" :hasAnyPremission="'MODULE_AREAMANAGERSTATISTICS:EXPORT'">
          <el-button class="chart-export chart-export-total" size="small" @click="exportChart('区域负责经营统计合计', totalUrl)">导出合计</el-button>
          <el-button class="chart-export" size="small" @click="exportChart('可回收物投递统计', recyclingUrl)">导出</el-button>
        </wt-auth>
        <div class="chart-item-canvas" id="saamRecyclingChart"></div>
      </div>
      <div class="chart-item">
        <div class="chart-item-tit">其他类型统计图</div>
        <wt-auth class="search-form-btn" :hasAnyPremission="'MODULE_AREAMANAGERSTATISTICS:EXPORT'">
          <el-button class="chart-export" size="small" @click="exportChart('其他类型统计', otherUrl)">导出</el-button>
        </wt-auth>
        <div class="chart-item-canvas" id="saamSHApplianceChart"></div>
      </div>
<!--      <div class="chart-item">
        <div class="chart-item-tit">耗材统计图</div>
        <div class="chart-item-canvas" id="saamConsumablesChart"></div>
      </div> -->
      <div class="chart-item chart-item-long">
        <div class="chart-item-tit">商品统计图</div>
        <wt-auth class="search-form-btn" :hasAnyPremission="'MODULE_AREAMANAGERSTATISTICS:EXPORT'">
          <el-button class="chart-export" size="small" @click="exportChart('商品统计', goodsUrl)">导出</el-button>
        </wt-auth>
        <div class="chart-item-canvas" id="saamGoodChart"></div>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from './mixin.js'
export default {
  name: 'StatisticalAnalysisAreaManager',
  mixins: [mixin],
  data() {
    return {
      form: {
        dataTimeRange: [],
        areaManagerId: ''
      },
      areaManagerOptions: [],
      totalUrl: '/modules/statisticalArea/garbageStatisticalImport4',
      recyclingUrl: '/modules/statisticalArea/garbageStatisticalImport1', // '/modules/statisticalArea/garbageStatisticalImport',
      otherUrl: '/modules/statisticalArea/otherStatisticalImport2', // '/modules/statisticalArea/otherStatisticalImport',
      goodsUrl: '/modules/statisticalArea/goodsStatisticalImport3', // '/modules/statisticalArea/goodsStatisticalImport',
      chartEle: {
        recyclingChart: null,
        consumablesChart: null,
        SHApplianceChart: null,
        goodChart: null
      }
    }
  },
  mounted() {
    const that = this
    window.addEventListener('resize', that.resizeView)
    this.initPage()
  },
  beforeDestroy() {
    const that = this
    window.removeEventListener('resize', that.resizeView)
  },
  methods: {
    // 初始化页面
    initPage() {
      // this.consumablesStatistical()
      this.garbageStatistical()
      this.goodsStatistical()
      this.otherStatistical()
      this.$store.dispatch('queryUserAreaManagerListNoPage').then(res => {
        this.areaManagerOptions = res
      })
    },
    toClickAction(type) {
      if (type === 'reset') {
        this.form = {
          dataTimeRange: [],
          areaManagerId: ''
        }
      }
      this.initPage()
    },
    exportChart(name, url) {
      const that = this
      const timer = (new Date()).getTime()
      const fileName = '区域负责人' + (name || '工单') + timer + '.xlsx'
      this.$wtUtil.downloadFile({
        url: window.wtConst.BASE_API + url,
        data: this.form,
        fileName: fileName
      }).then((res) => {
        console.log('导出成功')
      }).catch((err) => {
        that.$message({ message: err, type: 'error' })
      })
    },
    // 耗材统计
    consumablesStatistical() {
      this.$api.statistical.areaManager.consumablesStatistical(this.form).then(res => {
        this.$nextTick(() => {
          this.initConsumables(this.transResData(res.data, 1))
        })
      })
    },
    // 可回收物投递出库统计
    garbageStatistical() {
      this.$api.statistical.areaManager.garbageStatistical(this.form).then(res => {
        this.$nextTick(() => {
          this.initRecycling(this.transResData(res.data, 2))
        })
      })
    },
    // 商品统计
    goodsStatistical() {
      this.$api.statistical.areaManager.goodsStatistical(this.form).then(res => {
        this.$nextTick(() => {
          this.initGoods(this.transResData(res.data, 2))
        })
      })
    },
    // 其他类型统计
    otherStatistical() {
      this.$api.statistical.areaManager.otherStatistical(this.form).then(res => {
        this.$nextTick(() => {
          this.initSmallHomeAppliance(this.transResData(res.data, 1))
        })
      })
    },
    // 可回收物投递出库图
    initRecycling(data) {
      this.chartEle.recyclingChart = this.$echarts.init(document.getElementById('saamRecyclingChart'))
      this.chartEle.recyclingChart.setOption(this.createOption({
        legend: { top: '0', data: ['投递数', '出库数'] },
        chartName: '区域负责人统计-可回收物投递出库图',
        xNames: data.xNames,
        series: [
          {
            name: '投递数',
            type: 'bar',
            data: data.y1Names
          },
          {
            name: '出库数',
            type: 'bar',
            data: data.y2Names
          }
        ]
      }))
    },
    // 其他类型统计图
    initSmallHomeAppliance(data) {
      this.chartEle.SHApplianceChart = this.$echarts.init(document.getElementById('saamSHApplianceChart'))
      this.chartEle.SHApplianceChart.setOption(this.createOption({
        color: ['#94bfff'],
        chartName: '区域负责人统计-其他类型统计图',
        xNames: data.xNames,
        series: [
          {
            name: '',
            type: 'bar',
            barMaxWidth: 60,
            data: data.y1Names
          }
        ]
      }))
    },
    // 耗材统计图
    initConsumables(data) {
      this.chartEle.consumablesChart = this.$echarts.init(document.getElementById('saamConsumablesChart'))
      this.chartEle.consumablesChart.setOption(this.createOption({
        chartName: '区域负责人统计-耗材统计图',
        xNames: data.xNames,
        series: [
          {
            name: '',
            type: 'bar',
            barMaxWidth: 60,
            data: data.y1Names
          }
        ]
      }))
    },
    // 商品统计图
    initGoods(data) {
      this.chartEle.goodChart = this.$echarts.init(document.getElementById('saamGoodChart'))
      this.chartEle.goodChart.setOption(this.createOption({
        legend: { top: '0', data: ['配送数', '兑换数'] },
        color: ['#fa9a94', '#832a33'],
        chartName: '区域负责人统计-商品统计图',
        xNames: data.xNames,
        series: [
          {
            name: '配送数',
            type: 'bar',
            data: data.y1Names
          },
          {
            name: '兑换数',
            type: 'bar',
            data: data.y2Names
          }
        ]
      }))
    },
    // 重绘
    resizeView() {
      for (const key in this.chartEle) {
        if (this.chartEle[key]) {
          this.chartEle[key].resize()
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .chart-container .chart-item .chart-export.chart-export-total {
    right: 86px;
  }
</style>
